import type {MonacoLanguage} from 'llm/monaco/MonacoTypes';
import type {MolstarWrapperProps} from 'molbio/molstar/Viewer';

// Keep in sync with MAX_FILE_SIZE_FOR_PREVIEW_BYTES in benchling/external_files/mixins/previewable.py
const ONE_MEGABYTE = 1024 * 1024;
export const MAX_FILE_SIZE_FOR_PREVIEW_BYTES = 100 * ONE_MEGABYTE;

export const DISPLAY_ROW_LIMIT = 1000;

export const MOLSTAR_MIME_TYPE_TO_FORMAT: Record<string, MolstarWrapperProps['format']> = {
  'chemical/x-pdb': 'pdb',
  'chemical/x-pdbqt': 'pdbqt',
  'chemical/x-mmcif': 'mmcif',
};

export const TEXT_MIME_TYPES = new Set(['application/json', 'application/yaml', 'text/plain']);

export const CSV_MIME_TYPES = new Set(['text/csv', 'text/tsv']);

export const IMAGE_MIME_TYPES = new Set(['image/jpeg', 'image/png']);

export const CODE_MIME_TYPES: Record<string, MonacoLanguage> = {
  'text/x-python-script': 'python',
  'text/x-python': 'python',
};

const PLAIN_TEXT_EXTENSIONS = ['.log'];

export function isSupportedMimeType(mimeType: string | null | undefined, filename?: string): boolean {
  if (mimeType == null) {
    if (filename != null) {
      const lower = filename.toLowerCase();
      return PLAIN_TEXT_EXTENSIONS.some((ext) => lower.endsWith(ext));
    }
    return false;
  }
  return (
    TEXT_MIME_TYPES.has(mimeType) ||
    CSV_MIME_TYPES.has(mimeType) ||
    IMAGE_MIME_TYPES.has(mimeType) ||
    CODE_MIME_TYPES[mimeType] != null ||
    MOLSTAR_MIME_TYPE_TO_FORMAT[mimeType] != null ||
    mimeType === 'text/markdown' ||
    mimeType === 'text/html'
  );
}
